import React from 'react';

const CTA = () => {
  return (
    <section id='cta'>
      <div className='container tc'>
        <div className='s-64'></div>
        <h3 className='title-sub'>Освой профессию будущего</h3>
        <div className='s-32'></div>
        <h4 className='title-mini w-60 ma'>
          Начни зарабатывать на достойную жизнь
        </h4>
        <div className='s-48'></div>
        <div className='card tl b-none p-5'>
          <div className='m-5'>
            <div className='row'>
              <div className='col-lg-6'>
                <h3 className='title-sub w-100' style={{ lineHeight: 1.2 }}>
                  Выбери направление обучения прямо сейчас
                </h3>
                <div className='s-32'></div>
                <p className='title-card flex aic'>
                  <span>⭐</span>
                  <span className='px-2 pt-1'>Займет всего 7 минут</span>
                </p>
                <div className='s-40'></div>
                <a href='/' className='button'>
                  Подобрать направление
                </a>
              </div>
              <div className='col-lg-6'></div>
            </div>
          </div>
        </div>
        <div className='s-80'></div>
      </div>
    </section>
  );
};

export { CTA };
